import React, { useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import AppSidebar from './AppSidebar';
import { useContentSetting } from '../../Hooks/ContentSetting';
import { IconButton, Box } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';

export default function DashboardLayout() {
    const [mobileOpen, setMobileOpen] = useState(false);
    const { userInfo } = useContentSetting();

    if (!localStorage.getItem('token')) return <Navigate to="/login" />;
    if (userInfo?.type === 'school_admin' || userInfo?.flightSchool)
        return <Navigate to="/school/dashboard" />;

    return (
        <Box sx={{ display: 'flex', minHeight: '100vh', backgroundColor: '#FAF7F2' }}>
            {/* Mobile hamburger */}
            <IconButton
                onClick={() => setMobileOpen(!mobileOpen)}
                sx={{
                    display: { xs: 'flex', sm: 'none' },
                    position: 'fixed',
                    top: 14,
                    left: 14,
                    zIndex: 1200,
                    background: '#fff',
                    border: '1px solid rgba(26,26,26,0.12)',
                    borderRadius: '8px',
                    padding: '9px',
                    color: '#1a1a1a',
                    boxShadow: '0 1px 4px rgba(0,0,0,0.08)',
                }}
            >
                <MenuIcon sx={{ fontSize: 18 }} />
            </IconButton>

            <AppSidebar
                handleDrawerToggle={() => setMobileOpen(!mobileOpen)}
                mobileOpen={mobileOpen}
            />

            <Box
                component="main"
                sx={{
                    flexGrow: 1,
                    overflow: 'auto',
                    minHeight: '100vh',
                    backgroundColor: '#FAF7F2',
                }}
            >
                <Outlet />
            </Box>
        </Box>
    );
}
